<template>
    <div class="events-members profile-list">
        <user v-for="attendee in allAttendees" :owner="owner && attendee.id !== host" :key="attendee.id" :user="attendee">
            <ul slot="menu" v-if="type === 'banned'" class="dropdown-menu">
                <li><a href="#" @click.prevent="updateAttendee('unban', attendee)">{{ t.attendees.unban }}</a></li>
            </ul>
            <ul slot="menu" v-if="type === 'attendees'" class="dropdown-menu">
                <li><a href="#" @click.prevent="updateAttendee('ban', attendee)">{{ t.attendees.ban }}</a></li>
                <li><a href="#" @click.prevent="updateAttendee('remove', attendee)">{{ t.attendees.remove }}</a></li>
            </ul>
            <div slot="buttons" v-if="type === 'pending'" class="buttons two-buttons">
                <a href="#" class="btn btn-success" @click.prevent="updateAttendee('approve', attendee)">{{ t.attendees.approve }}</a>
                <a href="#" class="btn btn-danger" @click.prevent="updateAttendee('remove', attendee)">{{ t.attendees.deny }}</a>
            </div>
            <div slot="buttons" v-if="type === 'invite'" class="buttons one-button">
                <a href="#" class="btn btn-danger" @click.prevent="removeInvite('cancel', attendee)">{{ gt.common.cancel }}</a>
            </div>
        </user>
        <div class="clearfix"></div>
        <infinite v-if="canLoadMore && type === 'attendees' && infinite" :loading="loading" :handleOnMount="false" :handler="fetch"></infinite>
    </div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Infinite from 'Site/component/Infinite.vue';
import User from 'Profile/component/User.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'EventAttendees',
    components: {
        Infinite,
        User
    },
    computed: mapState(['gt', 't']),
    data() {
        return {
            allAttendees: this.attendees,
            canLoadMore: true,
            loading: false,
            offset: 25
        };
    },
    methods: {
        ...mapActions(['notify']),
        fetch() {
            this.loading = true;
            ajax.get('eventAttend', {
                'start-index': this.offset,
                'max-results': 25
            }).then((response) => {
                this.loading = false;
                this.offset += 25;
                if (response.items && response.items.length) {
                    response.items.forEach((item) => {
                        this.allAttendees.push(item);
                    });
                } else {
                    this.canLoadMore = false;
                }
            });
        },
        updateAttendee(action, attendee) {
            ajax.update('eventAttendee', {
                id: attendee.entity_id,
                action
            }).then((response) => {
                this.allAttendees = this.allAttendees.filter(checkAttendee => checkAttendee.id !== parseInt(attendee.id, 10));
                this.notify({ msg: response.message });
                this.$emit('eventattendeechange', { action, attendee });
            });
        },
        removeInvite(action, attendee) {
            ajax.delete('eventInvite', {
                id: attendee.entity_id,
                action
            }).then((response) => {
                this.allAttendees = this.allAttendees.filter(checkAttendee => checkAttendee.id !== parseInt(attendee.id, 10));
                this.notify({ msg: response.message });
            });
        }
    },
    props: {
        infinite: {
            type: Boolean,
            default: false
        },
        attendees: {
            type: Array,
            default() {
                return [];
            }
        },
        host: {
            type: Number,
            required: false,
            default: 0
        },
        owner: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'attendees'
        }
    }
};

</script>
